var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-nr-outer"},[(_vm.showCardNumber())?_c('span',{staticClass:"card-nr-inner"},[_vm._v(_vm._s(_vm.number))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }